import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PersonalInfoForm from '../responsive/PersonalInfoForm';
import ErrorMessage from '../../../components/common/ErrorMessage';
import { signout } from './../../../userauth/actions/signinAction';
import { showModal, hideModal, updateModal } from '../../../actions/shared/modal';
import Modal from '../../../components/common/Modal';
import Loader from '../../../components/common/Loader';
import { readCookie } from '../../../components/common/Cookie';
import UserProfileOTPVerification from './personal-info-user-otp';
import { getUserOtp, deleteUserAccount, verifyUserProfileOTP } from '../../actions/personalInfo';
import {
  getLuxeFlags,
  getShowOtpMessageForMobile,
  getShowOtpMessageForEmail,
  getAjioMassEmailIdOptionalWeb
} from '../../../Flags/selectors.js';
import {
  getUaas,
  getAccountDeletionFlag
} from '../../../refresh/selectors/featureFlagsSelector';
import { STREET_STORE } from '../../../constants/constant';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
class PersonalInfo extends React.Component {
  constructor() {
    super();
    this.state = {
      otp: '',
      secondsRemaining: 60,
      enableResendOTP: false,
      otpSendAgain: false,
      userResend: false,
      deleteAccountApiError: false,
      deleteAccountPersonalInfo: false,
      showDelAccontErrorToast: false
    };
    this.local = {
      timeout: ''
    };
    this.label = {
      otpTitle: 'Enter OTP To Access Profile',
      otpDescription: 'To access profile enter OTP sent to'
    };
  }

  componentDidMount() {
    const {
      personalInfo: { profile: { mobileNumber = '', displayUid = '', uid = '' } = {} } = {},
      reqAccountDeletion = false
    } = this.props;
    const userCookieData = {
      mobileNumber: decodeURIComponent(readCookie('MN')),
      emailId: decodeURIComponent(readCookie('U'))
    }
    document.title = 'Personal Information | AJIO';
    const userDetailObj = {
      mobileNumber: mobileNumber || userCookieData.mobileNumber,
      emailId: uid || userCookieData.emailId
    };
    // if (reqAccountDeletion) {
      this.props.fetchUserOtp(userDetailObj);
      this.callBackResendTimer();
      this.props.showModal('resend-otp-popup');
    // }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.personalInfo?.otpVerifyResponseObj !== nextProps.personalInfo?.otpVerifyResponseObj
    ) {
      if (nextProps.personalInfo?.otpVerifyResponseObj?.statusCode !== '0') {
        this.setState({ otpErrorMsg: nextProps.personalInfo?.otpVerifyResponseObj?.message });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      personalInfo: { otpSentSuccess = false } = {},
      isAccountDeletionEnabled = false,
      reqAccountDeletion = false
    } = this.props;
    const { userResend = false, secondsRemaining } = this.state;

    if (isAccountDeletionEnabled && reqAccountDeletion) {
      if (secondsRemaining === 0 && prevState.secondsRemaining !== secondsRemaining) {
        gtmEventPush({
          page_name: 'delete account opt half card',
          page_type: 'delete account opt half card',
          event: 'error_interactions',
          event_category: 'error interactions',
          event_action: 'delete profile',
          event_label: 'OTP timeout'
        });
        segmentEventPush({
          screen_name: 'Privacy Screen your data tab',
          page_name: 'Privacy Screen your data tab',
          // page_type: 'Privacy Screen your data tab',
          event: 'Delete Account OTP validation Status',
          event_category: 'error interactions',
          event_action: 'delete profile',
          status: 'failure',
          failure_reason: 'OTP timeout'
        });
      }
    }
    if (otpSentSuccess) {
      if (userResend) {
        this.setState({ otpSendAgain: true, userResend: false }, () => {
          setTimeout(() => {
            this.setState({ otpSendAgain: false });
          }, 10000);
        });
      }
    }
  }

  enterPressed = async(event, otp, mobileNumber) => {
    const ENTER_KEY = 13;
    if (event.keyCode === ENTER_KEY || event.charCode === ENTER_KEY) {
      // ENTER KEY PRESS
      event.preventDefault();
      const verifyOTPResponse = await this.props.verifyUserProfileOTP(otp, mobileNumber);
      const { isAccountDeletionEnabled = false, reqAccountDeletion = false } = this.props;
      
      if (isAccountDeletionEnabled && reqAccountDeletion) {
        this.setState({deleteAccountPersonalInfo : true})
        gtmEventPush({
          page_name: 'delete account opt half card',
          page_type: 'delete account opt half card',
          event: 'your_data_interactions',
          event_category: 'your data interactions',
          event_action: 'confirm OTP'
        });
        if (verifyOTPResponse?.message === 'success') {
          segmentEventPush({
            screen_name: 'Privacy Screen your data tab',
            page_name: 'Privacy Screen your data tab',
            // page_type: 'Privacy Screen your data tab',
            event: 'Delete Account OTP validation Status',
            event_category: 'your data interactions',
            event_action: 'confirm OTP',
            status: 'success'
          });
          const reason = {
            reason: 'other reason'
          };
          try {
            const delAccountResponse = await this.props.deleteUserAccount(reason);
            const { statusCode = '', success = '' } = delAccountResponse;
            if (statusCode === '200' && success == true) {
              this.props.signout(() => {
                this.props.showModal('account-deletion-request');
              })
            }
          } catch (error) {
            this.setState({
              deleteAccountApiError: true,
              showDelAccontErrorToast: true
            });
            console.error('Error deleting account:', error);     
          }
        } else {
          gtmEventPush({
            page_name: 'delete account opt half card',
            page_type: 'delete account opt half card',
            event: 'error_interactions',
            event_category: 'error interactions',
            event_action: 'delete profile',
            event_label: verifyOTPResponse?.message || 'wrong OTP entered'
          });
          segmentEventPush({
            screen_name: 'Privacy Screen your data tab',
            page_name: 'Privacy Screen your data tab',
            // page_type: 'Privacy Screen your data tab',
            event: 'Delete Account OTP validation Status',
            event_category: 'error interactions',
            event_action: 'delete profile',
            status: 'failure',
            failure_reason: verifyOTPResponse.message || 'wrong OTP entered'
          });
        }
      }
    }
  };

  submitUserOTP = async (event, otp, mobileNumber) => {
    event.preventDefault();
    const verifyOTPResponse = await this.props.verifyUserProfileOTP(otp, mobileNumber);
    const { isAccountDeletionEnabled = false, reqAccountDeletion = false } = this.props;
    
    if (isAccountDeletionEnabled && reqAccountDeletion) {
      this.setState({deleteAccountPersonalInfo : true})
      gtmEventPush({
        page_name: 'delete account opt half card',
        page_type: 'delete account opt half card',
        event: 'your_data_interactions',
        event_category: 'your data interactions',
        event_action: 'confirm OTP'
      });
      if (verifyOTPResponse?.message === 'success') {
        segmentEventPush({
          screen_name: 'Privacy Screen your data tab',
          page_name: 'Privacy Screen your data tab',
          // page_type: 'Privacy Screen your data tab',
          event: 'Delete Account OTP validation Status',
          event_category: 'your data interactions',
          event_action: 'confirm OTP',
          status: 'success'
        });
        const reason = {
          reason: 'other reason'
        };
        try {
          const delAccountResponse = await this.props.deleteUserAccount(reason);
          const { statusCode = '', success = '' } = delAccountResponse;
          if (statusCode === '200' && success == true) {
            this.props.signout(() => {
              this.props.showModal('account-deletion-request');
            })
          }
        } catch (error) {
          this.setState({
            deleteAccountApiError: true,
            showDelAccontErrorToast: true
          });
          console.error('Error deleting account:', error);
        }
      } else {
        gtmEventPush({
          page_name: 'delete account opt half card',
          page_type: 'delete account opt half card',
          event: 'error_interactions',
          event_category: 'error interactions',
          event_action: 'delete profile',
          event_label: verifyOTPResponse?.message || 'wrong OTP entered'
        });
        segmentEventPush({
          screen_name: 'Privacy Screen your data tab',
          page_name: 'Privacy Screen your data tab',
          // page_type: 'Privacy Screen your data tab',
          event: 'Delete Account OTP validation Status',
          event_category: 'error interactions',
          event_action: 'delete profile',
          status: 'failure',
          failure_reason: verifyOTPResponse.message || 'wrong OTP entered'
        });
      }
    }else{
      //assuming edit profile
      segmentEventPush({
        event:'Confirm OTP Clicked',
        screen_name: 'Edit Profile'
      });
    }
  };

  handleOTPChange = event => {
    this.setState({ otp: event.target.value });
  };

  resendOTP = (mobileNumber, emailId) => { 
    const userDetailObj = {
      mobileNumber,
      emailId
    };
    const { isAccountDeletionEnabled = false, reqAccountDeletion = false } = this.props;
    if (isAccountDeletionEnabled && reqAccountDeletion) {
      gtmEventPush({
        page_name: 'delete account opt half card',
        page_type: 'delete account opt half card',
        event: 'your_data_interactions',
        event_category: 'your data interactions',
        event_action: 'resend OTP'
      });
    }
    if (this.state.secondsRemaining === 0) {
      this.props.fetchUserOtp(userDetailObj, () => {
        if (this.props.personalInfo.otpResponseObj?.success == false) {
          this.setState({ otpErrorMsg: this.props.personalInfo.otpResponseObj?.message });
        } else {
          this.setState({ secondsRemaining: 60, userResend: true }, this.callBackResendTimer);
        }
      });
    }
  };

  callBackResendTimer() {
    const SEC = 1000;
    this.clearIntervalID = setInterval(this._decrease.bind(this), SEC);
  }

  _decrease() {
    let timer = this.state.secondsRemaining;

    if (timer > 0 && !this.state.errorMsg) {
      this.setState({ secondsRemaining: timer - 1 });
    } else {
      this.clearIntervalID && clearInterval(this.clearIntervalID);
      this.setState({ enableResendOTP: true });
    }
  }

  _getErrorStyle(isLuxe) {
    const isCartPage = window.location.href.includes('/cart');
    return {
      position: 'absolute',
      top: isLuxe ? (isCartPage ? '110px' : '165px') : isCartPage ? '100px' : '90px'
    };
  }

  render() {
    const {
      personalInfo = [],
      httpError = {},
      otp_popup_display_mobile,
      otp_popup_display_email,
      isUaas,
      newDesignLuxe,
      isEmailOptionalFlag,
      redirectOnClose = true,
      disableOutsideClick = true,
      reqAccountDeletion = false,
      isAccountDeletionEnabled = false,
    } = this.props;

    const {
      profile = {},
      otpVerifyResponseObj: { message = '', statusCode = '' } = {}
    } = personalInfo;
    const {
      otpErrorMsg,
      otp = '',
      secondsRemaining = '',
      enableResendOTP = '',
      otpSendAgain = false,
      deleteAccountPersonalInfo = false,
      deleteAccountApiError = false,
      showDelAccontErrorToast = false
    } = this.state;
    const showPersonalInfoForm =
      statusCode == '0' && !deleteAccountPersonalInfo && !deleteAccountApiError ? (
        <PersonalInfoForm
          source="desktop"
          profile={profile}
          getAjioMassEmailIdOptional={isEmailOptionalFlag}
        />
      ) : null;
    let { error: { errorType = '', message: errmessage = '' } = {} } = httpError;

    return !deleteAccountApiError ? (
      <div 
        className={`personal-info-section ${!reqAccountDeletion ? 'rightDiv' : ''}`}
        id="right-dev-container-accounts" 
        aria-labelledby="personal-info-header" 
        tabIndex={0}
        role="main"
      >
        {Object.keys(httpError).length !== 0 &&
          errorType === 'info' &&
          httpError.error.originator !== 'contact-detail' && (
            <div className="profile-update-info err-msg-blk">
              <ErrorMessage message={errmessage} showInfoIcon={false} />
            </div>
          )}
        <Loader name="mobile-num-popup" />
        <Modal
          name="otp-popup"
          ariaLabel="Enter OTP to access profile"
          className="user-profile-otp"
          disableOutsideClick={disableOutsideClick}
          redirect={redirectOnClose}
          onClose={() => {
            isAccountDeletionEnabled &&
              reqAccountDeletion &&
              gtmEventPush({
                page_name: 'delete account opt half card',
                page_type: 'delete account opt half card',
                event: 'your_data_interactions',
                event_category: 'your data interactions',
                event_action: 'close'
              });
          }}
        >
          <UserProfileOTPVerification
            {...this.props}
            otp={otp}
            otpTitle={this.label.otpTitle}
            otpDescription={this.label.otpDescription}
            handleOTPChange={this.handleOTPChange}
            submitUserOTP={this.submitUserOTP}
            resendOTP={this.resendOTP}
            personalInfo={personalInfo}
            message={otpErrorMsg}
            statusCode={statusCode}
            secondsRemaining={secondsRemaining}
            enableResendOTP={enableResendOTP}
            enterPressed={this.enterPressed}
            otpSendAgain={otpSendAgain}
            otp_popup_display_mobile={otp_popup_display_mobile}
            otp_popup_display_email={otp_popup_display_email}
          />
        </Modal>
        {showDelAccontErrorToast && (
          <div 
            className="err-msg-blk"
            style={this._getErrorStyle(newDesignLuxe)}
            aria-live="polite"
          >
            <ErrorMessage
              message={'Something went wrong. Try again'}
              device="desktop"
              showCloseButton={true}
              autoClose={true}
              onClose={() => this.setState({
                showDelAccontErrorToast: false
              })}
            />
          </div>
        )}
        {showPersonalInfoForm}
      </div>
    ) : (
      <>
        {reqAccountDeletion && isAccountDeletionEnabled ? (
          <div className="personal-info-section">
            <Loader name="mobile-num-popup" />
            <Modal
              name="otp-popup"
              className="user-profile-otp"
              disableOutsideClick={disableOutsideClick}
              redirect={redirectOnClose}
              onClose={() => {
                isAccountDeletionEnabled &&
                  reqAccountDeletion &&
                  gtmEventPush({
                    page_name: 'delete account opt half card',
                    page_type: 'delete account opt half card',
                    event: 'your_data_interactions',
                    event_category: 'your data interactions',
                    event_action: 'close'
                  });
              }}
            >
              <UserProfileOTPVerification
                {...this.props}
                otp={otp}
                otpTitle={this.label.otpTitle}
                otpDescription={this.label.otpDescription}
                handleOTPChange={this.handleOTPChange}
                submitUserOTP={this.submitUserOTP}
                resendOTP={this.resendOTP}
                personalInfo={personalInfo}
                message={otpErrorMsg}
                statusCode={statusCode}
                secondsRemaining={secondsRemaining}
                enableResendOTP={enableResendOTP}
                enterPressed={this.enterPressed}
                otpSendAgain={otpSendAgain}
                otp_popup_display_mobile={otp_popup_display_mobile}
                otp_popup_display_email={otp_popup_display_email}
              />
            </Modal>
            {showDelAccontErrorToast && (
              <div 
                className="err-msg-blk"
                style={this._getErrorStyle(newDesignLuxe)}
                aria-live="polite"
              >
                <ErrorMessage
                  message={'Something went wrong. Try again'}
                  device="desktop"
                  showCloseButton={true}
                  autoClose={true}
                  onClose={() => this.setState({
                    showDelAccontErrorToast: false
                  })}
                />
              </div>
            )}
          </div>
        ) : (
          <Loader name="auth-modal-loader" forceShow={true} />
        )}
      </>
    ); 
  }
}

const mapStatetoProps = state => {
  const { personalInfo = [], httpError = {}, flags = {} } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  return {
    personalInfo,
    httpError,
    otp_popup_display_mobile: getShowOtpMessageForMobile(flags),
    otp_popup_display_email: getShowOtpMessageForEmail(flags),
    isUaas: getUaas(state),
    isEmailOptionalFlag:
      getAjioMassEmailIdOptionalWeb(state.flags) &&
      getCurrentStore(state) === STREET_STORE &&
      getFeatureVariant('email-is-optional') !== '0',
    isAccountDeletionEnabled: getAccountDeletionFlag(flags),
    newDesignLuxe: isDesktopThemeEnable === 'ON' && storeName === 'luxe'
  };
};
PersonalInfo.propTypes = {
  signout: PropTypes.func,
  showModal: PropTypes.func,
  fetchUserOtp: PropTypes.func,
  verifyUserProfileOTP: PropTypes.func,
  deleteUserAccount: PropTypes.func
};
const mapDispatchToProps = dispatch => {
  return {
    signout: cb => {
      dispatch(signout(cb));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    deleteUserAccount: (reason = { reason: '' }) => dispatch(deleteUserAccount(reason)),
    fetchUserOtp: (userDetailObj, callbackOtp) => dispatch(getUserOtp(userDetailObj, callbackOtp)),
    verifyUserProfileOTP: (otp, mobileNumber) => dispatch(verifyUserProfileOTP(otp, mobileNumber))
  };
};

export default PersonalInfo = connect(mapStatetoProps, mapDispatchToProps)(PersonalInfo);
